import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  height: "78",
  viewBox: "0 0 135 78",
  width: "135",
  preserveAspectRatio: "xMidYMid meet"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M102.115 77.3709L134.282 0.0683594H84.2629L64.0531 77.3709H102.115ZM38.2856 77.3709L70.6213 0.0683594H20.602L0.22374 77.3709H38.2856Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }